import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseModel } from '../models/base-model';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})

export class AccountService {
  apiUrl: string
  constructor(
    private http: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}`
  }


  // Order API Methods
  getRecentOrders() {
    return this.http.post<any>(`${this.apiUrl}/orders/get_recent_orders`, {}).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  getSingleOrder(params) {
    return this.http.post<any>(`${this.apiUrl}/orders/get_order_by_id`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }
  // End of Order API Methods

  // Address API Methods
  createShippingAddress(params) {
    return this.http.post<any>(`${this.apiUrl}/addresses/create_shipping_address`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  editShippingAddress(params) {
    return this.http.post<any>(`${this.apiUrl}/addresses/edit_shipping_address`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  createBillingAddress(params) {
    return this.http.post<any>(`${this.apiUrl}/addresses/create_billing_address`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  editBillingAddress(params) {
    return this.http.post<any>(`${this.apiUrl}/addresses/edit_billing_address`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }
  // End of Address API Methods

  // User API Methods
  editUser(params) {
    return this.http.post<any>(`${this.apiUrl}/users/edit`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  getBillingAndShippingDetails(params) {
    return this.http.post<any>(`${this.apiUrl}/users/get_billing_and_shipping_details`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  editOrCreateShippingDetails(params) {
    return this.http.post<any>(`${this.apiUrl}/users/edit_or_create_shipping_details`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  editOrCreateBillingDetails(params) {
    return this.http.post<any>(`${this.apiUrl}/users/edit_or_create_billing_details`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }
  // End of User API Methods

  // Account API Methods
  createGuestAccount(params) {
    return this.http.post<any>(`${this.apiUrl}/accounts/create_guest_account`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  createCustomerAccount(params) {
    return this.http.post<any>(`${this.apiUrl}/accounts/create_account`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  getCustomerAccount() {
    return this.http.get<any>(`${this.apiUrl}/accounts/get_account`).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
    ))
  }
  //  Not implemented api side yet... (11-19-2021)
  updateCustomerAccount(params) {
    return this.http.post<any>(`${this.apiUrl}/accounts/update_account`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  createCustomerPaymentProfile(params) {
    return this.http.post<any>(`${this.apiUrl}/accounts/create_customer_payment_profile`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  createCustomerShippingAddress(params) {
    return this.http.post<any>(`${this.apiUrl}/accounts/create_customer_shipping_address`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  deleteCustomerPaymentProfile(params) {
    return this.http.post<any>(`${this.apiUrl}/accounts/delete_customer_payment_profile`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  // Optimal if charge customer profile is used (11-19-2021)
  chargeCustomerCreditCard(params) {
    return this.http.post<any>(`${this.apiUrl}/accounts/charge_customer_credit_card`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }
  //  Not implemented api side yet... (11-19-2021)
  // Optimal if charge customer profile is used (11-19-2021)
  chargeCustomerBankAccount(params) {
    return this.http.post<any>(`${this.apiUrl}/accounts/charge_customer_bank_account`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }

  chargeCustomerProfile(params) {
    return this.http.post<any>(`${this.apiUrl}/accounts/charge_customer_profile`, params).pipe(
      catchError(this.handleError),
      map((res: BaseModel) => {
        return this.handleBaseResponse(res)
      }
      ))
  }
  // End of Account API Methods

  private handleBaseResponse(res: BaseModel) {
    if (res.success) {
      return res.payload
    } else {
      throwError(res.errors)
      return res
    }
  }

  private handleError(error) {
    let errorMessage = ''
    // server-side error
    errorMessage = `Error Code: ${error.status}\nMessage: ${error['error']['errors']}`
    return throwError({ status: error.status, msg: errorMessage })
  }


}
